"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findVaultAddress = exports.findPoolAddress = void 0;
const tslib_1 = require("tslib");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
/**
 * Finds the address of the Pool.
 * @returns
 */
const findPoolAddress = ({ programId = constants_1.SUNNY_ADDRESSES.SunnyPoolQuarry, creator, quarry, }) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("SunnyQuarryPool"),
        creator.toBuffer(),
        quarry.toBuffer(),
    ], programId);
});
exports.findPoolAddress = findPoolAddress;
/**
 * Finds the address of the Vault.
 * @returns
 */
const findVaultAddress = ({ programId = constants_1.SUNNY_ADDRESSES.SunnyPoolQuarry, pool, owner, }) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("SunnyQuarryVault"),
        pool.toBuffer(),
        owner.toBuffer(),
    ], programId);
});
exports.findVaultAddress = findVaultAddress;
//# sourceMappingURL=pda.js.map